import styled, { css } from 'styled-components'
import Lottie from 'lottie-react'
import { lighten } from 'polished'
import { motion } from 'framer-motion'
import LinearProgressComponent from '@mui/material/LinearProgress'

import { TypographyComponent } from 'src/components/Typography'
import { IToastBaseProps } from '.'

interface ILinerProgressProps {
  type: string
}

interface ITitleProps {
  type: string
}

export const Wrapper = styled(motion.div)<IToastBaseProps>(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #fff;
    border-radius: ${theme.layout.borderRadius};
    border: solid 0.1rem ${theme.colors.base.gray};
    z-index: 99998;
    transition: 0.5s;
    left: 0;
    margin-top: 0.8rem;
    &:first-child {
      margin-top: 0;
    }

    @media (max-width: ${theme.screen.medium}) {
      top: initial;
      bottom: 0;
    }
  `
)

export const ContentWrapper = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 1.6rem;
  `
)

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-family: ${theme.typograph.fontFamily.primary};
    font-size: ${theme.typograph.fontsize.h4};

    @media (max-width: ${theme.screen.medium}) {
      font-size: ${theme.typograph.fontsize.h3};
    }
  `
)

export const Title = styled(TypographyComponent)<ITitleProps>(
  ({ theme, type }: any) => css`
    && {
      font-weight: 500;
      font-size: ${theme.typograph.fontsize.h4};
      font-family: ${theme.typograph.fontFamily.primary};
      letter-spacing: 0.0257143rem;
      color: ${theme.colors[type].main};
      margin-bottom: 1.6rem;

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h3};
      }
    }
  `
)

export const Message = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-weight: 400;
      line-height: 2.2rem;
      letter-spacing: 0.01rem;
      font-family: ${theme.typograph.fontFamily.primary};
      font-size: ${theme.typograph.fontsize.h3};
      color: rgba(0, 0, 0, 0.6);

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h3};
      }
    }
  `
)

export const LottieAnimation = styled(Lottie)(
  () => css`
    max-width: 11rem;
  `
)

export const LinearProgress = styled(
  LinearProgressComponent
)<ILinerProgressProps>(
  ({ theme, type }: any) => css`
    && {
      width: 99%;
      background-color: ${lighten(0.3, theme.colors[type].main)};
      border-radius: ${theme.layout.borderRadius};

      .MuiLinearProgress-bar {
        background-color: ${theme.colors[type].main};
      }
    }
  `
)
